var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1553",
    "data-name": "Component 1553",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10723",
    "data-name": "Rectangle 10723",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13317",
    "data-name": "Group 13317",
    transform: "translate(-9642.137 -12166.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13316",
    "data-name": "Group 13316",
    transform: "translate(9648.137 12169.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10739",
    "data-name": "Path 10739",
    d: "M101.018,34.743a1.569,1.569,0,0,0,2.512,0l3.768-4.714a6.274,6.274,0,1,0-10.047,0Z",
    transform: "translate(-96 -20)",
    fill: "none",
    stroke: "#6a91fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 3.145,
    cy: 3.145,
    r: 3.145,
    transform: "translate(3.09 3.172)",
    fill: "none",
    stroke: "#6a91fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10740",
    "data-name": "Path 10740",
    d: "M107.968,378.352a1.942,1.942,0,0,1,.58,1.32c0,1.733-2.809,3.137-6.274,3.137S96,381.4,96,379.672a1.942,1.942,0,0,1,.58-1.32",
    transform: "translate(-96 -364.3)",
    fill: "none",
    stroke: "#6a91fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a2f6fb0fdbf57314bcc30316ce0cc08b.svg";
export { ForwardRef as ReactComponent };